export default "__VITE_ASSET__DYq4d9$K__"